import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import EnvProvider from "./context/EnvContext";
import TagManager from "@sooro-io/react-gtm-module";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;

if (DSN) {
  Sentry.init({
    dsn: DSN,
    environment: process.env.REACT_APP_ENV || "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", "getfulllproof.com"],
  });
}

if (process.env.REACT_APP_GTM_ID) {
  TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
}

const PostHog = ({ children }) => {
  if (!process.env.REACT_APP_POSTHOG_KEY) return children;

  return (
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true,
        debug: process.env.NODE_ENV === "development",
      }}
    >
      {children}
    </PostHogProvider>
  )
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <EnvProvider>
      <PostHog>
        <App />
      </PostHog>
    </EnvProvider>
  </React.StrictMode>
);
